module.exports = __webpack_public_path__ + "img/sport-91-@1x.5a4370f4.png";